var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 3.5C5.28683 3.5 5.46705 3.59099 5.58008 3.74512L6.32031 4.75488C6.43328 4.90886 6.61275 4.99989 6.80371 5H12.4004C12.7315 5.00021 12.9998 5.26855 13 5.59961V11.9004C12.9998 12.2315 12.7315 12.4998 12.4004 12.5H3.59961C3.26855 12.4998 3.00021 12.2315 3 11.9004V4.09961C3.00021 3.76855 3.26855 3.50021 3.59961 3.5H5.0957ZM8.06934 5.89941C7.90673 5.89945 7.75071 5.96609 7.6377 6.08301L5.70508 8.08301C5.47518 8.32125 5.48174 8.70146 5.71973 8.93164C5.95798 9.16155 6.33817 9.15499 6.56836 8.91699L7.46875 7.98535V11C7.46888 11.3312 7.73811 11.5995 8.06934 11.5996C8.40054 11.5995 8.66881 11.3312 8.66895 11V7.98438L9.57031 8.91699C9.80057 9.15486 10.1808 9.16165 10.4189 8.93164C10.6571 8.70142 10.6627 8.32128 10.4326 8.08301L8.50098 6.08301C8.38798 5.96619 8.23187 5.89946 8.06934 5.89941Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToFolder);
export default __webpack_public_path__ + "static/media/Move_to_folder.d12b83965c1c4074d8d28804d169e83f.svg";
export { ForwardRef as ReactComponent };